import { applyMiddleware, combineReducers, createStore as reduxCreateStore } from "redux"
import thunk from "redux-thunk"
import app from "./app"


export default function createStore() {
  let middleWares = [thunk]

  return reduxCreateStore(
    combineReducers({
      app
    }),
    applyMiddleware(...middleWares)
  )
}

